import React, { useCallback, useMemo, useRef } from 'react';
import { abbreviateNumber, useOutsideClick } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { freeBetStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { doBetStore } from '../../store/doBetStore';
import chipImg1 from '../../assets/images/chips/yellow.png';
import chipImg2 from '../../assets/images/chips/black.png';
import chipImg3 from '../../assets/images/chips/BrownGreen.png';
import chipImg4 from '../../assets/images/chips/green.png';
import chipImg5 from '../../assets/images/chips/purple.png';
import chipImg6 from '../../assets/images/chips/red.png';
import freeChipImg from '../../assets/images/chips/free-chip.png';

export const MobileChipSection = observer(() => {
  const { quickBets, selectedChip, setSelectedChip } = doBetStore;
  const settingsRef = useRef();
  const { balance } = userInfoStore;
  const { activeFreeBet } = freeBetStore;
  const handleSelectChips = useCallback((chip) => setSelectedChip(chip), [setSelectedChip]);
  const [opened, handleClick] = useOutsideClick(settingsRef);

  const memoChip = useMemo(() => {
    const chipsImages = [chipImg1, chipImg2, chipImg3, chipImg4, chipImg5, chipImg6];
    return quickBets?.map((item, index) => ({ ...item, img: chipsImages[index] }));
    // eslint-disable-next-line
  }, [handleSelectChips, selectedChip, quickBets, balance]);

  const selectedChipInfo = memoChip?.find((item) => item.chip === selectedChip);

  return (
    <div className={`chips-section-wrp ${opened ? 'switch-e' : ''}`} ref={settingsRef}>
      <div className='chips-section-cont'>
        {' '}
        {/* add/remove switch class */}
        <div className='chips-main-container'>
          <div className='chips-all-wrp' onClick={activeFreeBet.id ? null : handleClick}>
            {!activeFreeBet.id &&
              memoChip
                .filter((item, index) => index < 2)
                .reverse()
                .map(({ chip, img }) => (
                  <div key={img} className='chips-big-cont-block'>
                    <img src={img} alt='' />
                    <p>{abbreviateNumber(chip)}</p>
                  </div>
                ))}
            <div className='chips-big-cont-block'>
              <img src={activeFreeBet.id ? freeChipImg : selectedChipInfo?.img} alt='' />
              <p>
                {abbreviateNumber(activeFreeBet.id ? activeFreeBet.amount : selectedChipInfo?.chip)}
              </p>
            </div>
          </div>
        </div>
        <div className='chips-big-cont'>
          {memoChip
            .filter((item, index) => index < 6)
            ?.reverse()
            .map(({ chip, img }) => (
              <div
                key={img}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectChips(chip);
                }}
                className={`chips-big-cont-block ${chip > balance ? 'disabled' : ''}`}
              >
                <img src={img} alt='' />
                <p>{abbreviateNumber(chip)}</p>
              </div>
            ))}
          <div
            className={`chips-big-cont-block active ${selectedChipInfo?.color} ${
              selectedChipInfo?.chip > balance ? 'disabled' : ''
            }`}
          >
            <img src={selectedChipInfo?.img} alt='' />
            <p>{selectedChipInfo?.chip}</p>
          </div>
        </div>
      </div>
    </div>
  );
});
